import { useQuery } from "@tanstack/react-query";

import api from "../apiClient";

import cookiesHelper from "../../helpers/cookies";

import { EtyCampus } from "../../interfaces/entities";

const useGetCampuses = () => {
    const queryFn = async (): Promise<EtyCampus[]> => {
        const token = cookiesHelper.getCookie((process.env.REACT_APP_AUTH_TOKEN_NAME as string));
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        const res = await api.get(`campuses`);
        return res.data?.length ? res.data : [];
    };

    return useQuery({
        queryKey: ['campuses'],
        queryFn,
        retry: 0,
    });
};

export default useGetCampuses;